import { initEventRegistry, enableLocalDev } from "./eventRegistry";

export { enableLocalDev };
initEventRegistry();
